var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"success-box"},[_c('div',{staticClass:"success-box"},[_c('div',{staticClass:"success-box-icon"},[_c('svg-icon',{attrs:{"icon-class":"success","className":"success-svg"}})],1),_c('div',{staticClass:"notice"},[_vm._v("提交成功")]),_c('div',{staticClass:"content"},[_vm._v("感谢你提出的宝贵意见~")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }